import { render } from "./SendSearch.vue?vue&type=template&id=91a94464&scoped=true&ts=true"
import script from "./SendSearch.vue?vue&type=script&lang=ts"
export * from "./SendSearch.vue?vue&type=script&lang=ts"

import "./SendSearch.vue?vue&type=style&index=0&id=91a94464&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a94464"]])

export default __exports__